import apiPath from '../../../config/api';

const PurchaseSalesPath = {
    title: "Toko Material - Pembelian dan Penjualan",
    basePath: "/material/jual-beli",
    base: apiPath.retailPurchaseSales,
    purchaseSalesExcel: apiPath.retailPurchaseSalesExcel,
    purchaseSalesFind: apiPath.retailPurchaseSalesFind
}

export default PurchaseSalesPath;
